import { useEffect } from 'react';
import { Navigate, useLocation, useRoutes } from 'react-router-dom';
import { HeaderAndFooter } from '../layouts';
import { RedirectToLineItemState, TabPanel } from '../components';
import PrivateRoutes from './PrivateRoute';
import { connect } from 'react-redux';
import { AT_STATION_TAB, NEW_PROCESSED_TAB, PROCESSED_TAB, UPCOMING_TAB, OPERATIONS } from '../constants';
import {
	Login,
	Assembly,
	GenerateSerialNumber,
	PrintBarcode,
	ScanVin,
	Booking,
	ReceivePart,
	PlatePunchingStart,
	PartValidationContainer,
	Machine,
	WTCL,
	QualityandDefect,
	SFLT,
	BodyAlign,
	Waha,
	Rbt,
	PaintSelect,
	PreCal,
	Dt,
	Shower,
	TransferDrop,
	MajorRepair,
} from '../pages';
import ProcessedPage from '../pages/ProcessedPage/ProcessedPage';
import UpcomingParts from '../pages/UpcomingParts/UpcomingParts';
import { updateTab } from '../redux/actionCreators/tab';
import Engraving from '../pages/Engraving/Engraving';
import ProcessValidationContainer from '../pages/ProcessValidationContainer/ProcessValidationContainer';
import BookingContainer from '../pages/BookingContainer/BookingContainer';
import NewProcessedPage from '../pages/Processed/NewProcessedPage';
import WcpaAudit from '../pages/WCPA/WcpaAudit';

const mapStateToProps = (state) => {
	return {
		tabValue: state.tab.tabValue,
		allowedOperations: state.operations.allowedOperations,
	};
};

const mapDispatchToProps = (dispatch) => ({
	updateTab: (data) => dispatch(updateTab(data)),
});

export function Router(props) {
	const { updateTab, tabValue, allowedOperations } = props;
	const location = useLocation();

	useEffect(() => {
		updateTab({
			tabValue: parseInt(localStorage.getItem('tabValue')) || 0,
		});
	}, [updateTab]);

	// ✅ FIX 1: Keep At Station tab active on root '/' path
	useEffect(() => {
		if (location.pathname === '/' && tabValue !== AT_STATION_TAB) {
			updateTab({ tabValue: AT_STATION_TAB });
		}
	}, [location.pathname, tabValue, updateTab]);

	// ✅ FIX 2: Keep At Station tab active on scan-vin route
	useEffect(() => {
		if (location.pathname === '/scan-vin' && tabValue !== AT_STATION_TAB) {
			updateTab({ tabValue: AT_STATION_TAB });
		}
	}, [location.pathname, tabValue, updateTab]);

	return useRoutes([
		{ path: 'login', element: <Login /> },
		{
			path: '',
			element: (
				<PrivateRoutes>
					<RedirectToLineItemState>
						<HeaderAndFooter>
							<TabPanel value={tabValue} index={AT_STATION_TAB}>
								{(allowedOperations?.includes(OPERATIONS.TRANSFER_DROP)) ? (
									<TransferDrop />
								) : (
									<ReceivePart />
								)}
							</TabPanel>
						</HeaderAndFooter>
					</RedirectToLineItemState>
				</PrivateRoutes>
			),
		},
		{
			path: 'scan-vin',
			element: (
				<PrivateRoutes>
					<HeaderAndFooter>
						<TabPanel value={tabValue} index={AT_STATION_TAB}>
							<ScanVin />
						</TabPanel>
					</HeaderAndFooter>
				</PrivateRoutes>
			),
		},
		{
			path: 'transfer-drop',
			element: (
				<PrivateRoutes>
					<RedirectToLineItemState>
						<HeaderAndFooter>
							<TabPanel value={tabValue} index={AT_STATION_TAB}>
								<TransferDrop />
							</TabPanel>
						</HeaderAndFooter>
					</RedirectToLineItemState>
				</PrivateRoutes>
			),
		},
		{
			path: 'assembly',
			element: (
				<PrivateRoutes>
					<RedirectToLineItemState>
						<HeaderAndFooter>
							<Assembly />
						</HeaderAndFooter>
					</RedirectToLineItemState>
				</PrivateRoutes>
			),
			children: [
				{ path: '', element: <Navigate to="/assembly/generate-serial-no" /> },
				{ path: 'part-validation', element: <PartValidationContainer /> },
				{ path: 'process-validation', element: <ProcessValidationContainer /> },
				{ path: 'receive-part', element: <ReceivePart /> },
				{ path: 'engraving', element: <Engraving /> },
				{ path: 'machine', element: <Machine /> },
				{ path: 'wtcl', element: <WTCL /> },
				{ path: 'quality-defect', element: <QualityandDefect /> },
				{ path: 'wcpa', element: <WcpaAudit /> },
				{ path: 'sflt', element: <SFLT /> },
				{ path: 'body-align', element: <BodyAlign /> },
				{ path: 'waha', element: <Waha /> },
				{ path: 'rbt', element: <Rbt /> },
				{ path: 'paint-select', element: <PaintSelect /> },
				{ path: 'pre-cal', element: <PreCal /> },
				{ path: 'dt', element: <Dt /> },
				{ path: 'shower', element: <Shower /> },
				{ path: 'station/major-repair', element: <MajorRepair /> },
				{ path: 'major-repair/receive-part', element: <MajorRepair /> },
				{ path: 'Major-repair/receive-part', element: <MajorRepair /> },
				{ path: 'book', element: <BookingContainer /> },
			],
		},
		{
			path: 'processed-line-item',
			element: (
				<PrivateRoutes>
					<HeaderAndFooter>
						<TabPanel
							value={tabValue}
							index={PROCESSED_TAB}
							sx={{ height: '100%' }}
							boxStyles={{
								height: '100%',
								paddingY: 0,
								paddingX: 2,
							}}
						>
							<ProcessedPage />
						</TabPanel>
					</HeaderAndFooter>
				</PrivateRoutes>
			),
		},
		{
			path: 'upcoming-line-item',
			element: (
				<PrivateRoutes>
					<HeaderAndFooter>
						<TabPanel
							value={tabValue}
							index={UPCOMING_TAB}
							sx={{ height: '100%' }}
							boxStyles={{
								height: '100%',
								paddingY: 0,
								paddingX: 2,
							}}
						>
							<UpcomingParts />
						</TabPanel>
					</HeaderAndFooter>
				</PrivateRoutes>
			),
		},
		{
			path: 'processed',
			element: (
				<PrivateRoutes>
					<HeaderAndFooter>
						<TabPanel
							value={tabValue}
							index={NEW_PROCESSED_TAB}
							sx={{ height: '100%' }}
							boxStyles={{ height: '100%', paddingY: 0, paddingX: 2 }}
						>
							{allowedOperations?.includes(OPERATIONS.MAJOR_REPAIR) ? (
								<MajorRepair view="processed" />
							) : (
								<NewProcessedPage
									stationName={
										allowedOperations?.includes(OPERATIONS.WCPA)
											? "WCPA"
											: ""
									}
								/>
							)}
						</TabPanel>
					</HeaderAndFooter>
				</PrivateRoutes>
			),
		},
	]);
}

export default connect(mapStateToProps, mapDispatchToProps)(Router);
